import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import { isEmpty } from '../utils/helpers';
var borderRadiusStyles = function borderRadiusStyles(edges, theme) {
  if (edges === 'rounded') {
    return 99;
  }
  if (edges === 'sharp') {
    return 0;
  }
  return theme.shape.borderRadius;
};
export var StyledAutocomplete = styled(Autocomplete)(function (_ref) {
  var iconrotation = _ref.iconrotation;
  return {
    '& .MuiAutocomplete-popupIndicatorOpen': {
      transform: iconrotation === 'yes' ? null : 'rotate(0)'
    }
  };
});
export var StyledInput = styled(TextField)(function (_ref2) {
  var edges = _ref2.edges,
    required = _ref2.required,
    size = _ref2.size,
    val = _ref2.val,
    theme = _ref2.theme,
    variant = _ref2.variant;
  return {
    margin: 0,
    '&& .MuiInputBase-root': {
      width: '100%',
      padding: size === 'small' ? "" + theme.spacing(2, 8, 2, 2) : '12px 16px',
      border: variant === 'filled' ? "2px solid transparent" : null,
      borderRadius: borderRadiusStyles(edges, theme)
    },
    '& .MuiFilledInput-root': {
      backgroundColor: theme.palette.grey.transparent
    },
    '& .Mui-focused': {
      border: variant === 'filled' ? "2px solid " + (required ? theme.palette.secondary.main : theme.palette.primary.main) : null
    },
    '& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: required && isEmpty(val) ? theme.palette.secondary.main : null
    },
    '& input': {
      padding: '0 !important'
    },
    '& .MuiTouchRipple-root': {
      display: 'none'
    }
  };
});